<template>
  <section class="pv-feat" aria-labelledby="preventa-features-title">
    <h2 id="preventa-features-title" class="wd-title">
      <span class="hl">Características</span> <span class="pv-feat__base">generales</span>
    </h2>

    <ul class="pv-feat__grid">
      <li v-for="feature in features" :key="feature.title" class="pv-feat__card">
        <img :src="feature.icon" alt="" aria-hidden="true">
        <div class="pv-feat__text">
          <h3 class="pv-feat__title">{{ feature.title }}</h3>
          <p class="wd-body">{{ feature.description }}</p>
        </div>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import icon1 from '../../../assets/preventa-figma/ic-1.svg'
import icon2 from '../../../assets/preventa-figma/ic-2.svg'
import icon3 from '../../../assets/preventa-figma/ic-3.svg'
import icon4 from '../../../assets/preventa-figma/ic-4.svg'
import icon5 from '../../../assets/preventa-figma/ic-5.svg'

const features = [
  { icon: icon1, title: 'Tipo de vivienda', description: 'Vivienda nueva' },
  { icon: icon2, title: 'Vendedor', description: 'Desarrollador o constructor' },
  { icon: icon3, title: 'Comprador', description: 'Persona física' },
  { icon: icon4, title: 'Primer pago', description: 'Hasta 18 meses de gracia' },
  { icon: icon5, title: 'Plazo del contrato', description: '180 meses' },
  { icon: icon5, title: 'Domiciliación', description: 'Requerida desde la contratación' }
]
</script>

<style scoped>
.pv-feat { display: flex; flex-direction: column; gap: var(--ds-space-7); }
.pv-feat__base { color: var(--ds-purple-900); }
.pv-feat .wd-title { height: 40px; line-height: 44px; }

.pv-feat__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--ds-space-5);
  margin: 0;
  padding: 0;
  list-style: none;
}

.pv-feat__card {
  display: flex;
  align-items: center;
  gap: var(--ds-space-4);
  min-height: 104px;
  /* El borde de 1px va dentro de las medidas del Figma (16px de padding incluyendo el trazo) */
  padding: calc(var(--ds-space-4) - 1px);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border: 1px solid var(--ds-border-card);
  border-radius: 8px;
}
.pv-feat__card img { flex: 0 0 40px; width: 40px; height: 40px; }

.pv-feat__text { display: flex; flex: 1 1 0; flex-direction: column; gap: var(--ds-space-3); min-width: 0; }
.pv-feat__title {
  margin: 0;
  color: var(--ds-secondary-main);
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
}

@media (max-width: 1024px) {
  .pv-feat__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 599px) {
  .pv-feat__grid { grid-template-columns: minmax(0, 1fr); gap: var(--ds-space-3); }
  /* En mobile las seis cards miden 117.33px de alto en el Figma */
  .pv-feat__card { min-height: 117.33px; }
}
</style>
